import BaseControlTypeConst from "./BaseControlTypeConst"

export default class CrudTableTypeConst extends BaseControlTypeConst {
  
    static SHOWBTNSEARCH='showBtnSearch'
    static SHOWBTNCLEAR='showBtnClear'
    static SHOWBTNCLOSETABS='showBtnCloseTabs'
    static EDITALLEXCEPTKEYS='editAllExceptKeys'
    static MAXREGS='maxRegs'
    static CANADDNEWITEM='canAddNewItem'
    static CANIMPORT='canImport'
    static SHOWACTIONMENU='showActionMenu'
    static SHOWSEARCH='showSearch'
    static SHOWACTIONDETAIL='showActionDetail'
    static SHOWPAGINATE='showPaginate'  
    static CANDELETEITEM='canDeleteItem'
    static SELECTEDROW='selectedRow'
    static LAYOUT_DETAIL ='layouttemp-crudtbl-detail'
    static LAYOUT_HEADER ='layouttemp-crudtbl-header'
    static LAYOUT_HEADER_BUTTONS ='layouttemp-crudtbl-headerbtns'
    static LAYOUT_ADDNEW ='layouttemp-crudtbl-new'
    static LAYOUT_ACTIONS_MENU ='layouttemp-crudtbl-menu'    
    static CANUPDATEMASSIVE='canUpdateMassive'
    static SHOWHEADERDETAIL='showHeaderDetail'  
   
  }
  